


































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Severity } from '@sentry/types';

interface IHomeGetStarted extends Vue {
  setTotalAcquisitions(): void;
}

@Component<IHomeGetStarted>({
  async created() {
    await this.setTotalAcquisitions();
  },
})
export default class HomeGetStarted extends Vue {
  @Prop({ required: true }) private totalPatient!: number | null;

  totalAcquisitions: number | null = null;

  get soles() {
    return this.$pdc.entities!.soles.storedEntity;
  }

  get acquisitions() {
    return this.$pdc.entities!.acquisitions.storedEntity;
  }

  get officesLength() {
    return this.$pdc.doctor!.current?.offices.items.length || 0;
  }

  get state() {
    return {
      doctor: {
        value: this.officesLength ? 100 : 0,
        valid: this.officesLength,
      },
      soles: {
        value: (this.soles.total / 6) * 100,
        valid: this.soles.total >= 6,
      },
      patient: {
        value: this.totalPatient ? 100 : 0,
        valid: this.totalPatient,
      },
      acquisition: {
        value: this.totalAcquisitions ? 100 : 0,
        valid: this.totalAcquisitions,
      },
    };
  }

  get isValid() {
    return Object.values(this.state).filter((x) => x.valid).length === 4;
  }

  @Watch('isValid', { immediate: true })
  onIsValidChanged(value: boolean) {
    if (value) {
      this.setCompleted();
    }
  }

  async setTotalAcquisitions() {
    const result = await this.$pdc.doctor!.getTotalAcquisitionsWithoutDemo();
    this.totalAcquisitions = result.total;
  }

  startAcquisition() {
    this.$emit('startAcquisition');
  }

  async setCompleted() {
    try {
      // Try to patch the doctor ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data: {
          getStarted: {
            completed: true,
          },
        },
      });
    } catch (e) {
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Critical);
    }
  }
}
